<div id="carouselImages" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner">
    <div
      *ngFor="let media of denounce.media; let i = index"
      class="carousel-item"
      [attr.data-slide-to]="image"
      [class.active]="i === 0"
    >
      <img
        *ngIf="imageType !== 'mp4'"
        src="{{ denounce.media[image] }}"
        alt="imagens do registro"
        class="img-fluid d-block w-100"
        data-target="#carouselImages"
        [attr.data-slide-to]="image"
      />
      <video controls *ngIf="imageType === 'mp4'" alt="video do registro">
        <source [src]="denounce.media[image]" type="video/mp4" />
      </video>
    </div>
  </div>
  <a
    class="carousel-control-prev"
    role="button"
    data-slide="prev"
    (click)="prev()"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a
    class="carousel-control-next"
    role="button"
    data-slide="next"
    (click)="next()"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
